import React from 'react';
import { MOVIE_GROUPS, MOVIES_NEXT_STEPS } from './movies/constants';
import {
  formatCategoryLabel,
  getFavoriteSectionAccentClassName,
  getFavoriteSectionEmptyMessage,
} from './movies/categoryUtils';
import { useMovieSubmissions } from './movies/hooks/useMovieSubmissions';
import { useMoviesAdminAccess } from './movies/hooks/useMoviesAdminAccess';
import MoviesAdminAccessModal from './movies/components/MoviesAdminAccessModal';
import MoviesAdminAccessSection from './movies/components/MoviesAdminAccessSection';
import MoviesCtaSection from './movies/components/MoviesCtaSection';
import MoviesHeroSection from './movies/components/MoviesHeroSection';
import MoviesListsSection from './movies/components/MoviesListsSection';
import MoviesRoadmapSection from './movies/components/MoviesRoadmapSection';

const isMoviesAdminSurfaceEnabled = process.env.REACT_APP_MOVIES_ADMIN_SURFACE_ENABLED !== 'false';

const Movies = () => {
  const { favoritesLoadStatus, submissionsByColumn, favoritesByCategory, favoriteSectionKeys } =
    useMovieSubmissions();

  const {
    isAdminAccessModalOpen,
    adminSecret,
    setAdminSecret,
    adminAccessStatus,
    adminAccessMessage,
    handleOpenAdminAccessModal,
    handleCloseAdminAccessModal,
    handleAdminAccessSubmit,
  } = useMoviesAdminAccess();

  return (
    <>
      <MoviesHeroSection />

      <div className="site-bg-section py-20 px-6">
        <div className="container mx-auto">
          <MoviesListsSection
            favoriteSectionKeys={favoriteSectionKeys}
            favoritesByCategory={favoritesByCategory}
            favoritesLoadStatus={favoritesLoadStatus}
            movieGroups={MOVIE_GROUPS}
            submissionsByColumn={submissionsByColumn}
            formatCategoryLabel={formatCategoryLabel}
            getFavoriteSectionAccentClassName={getFavoriteSectionAccentClassName}
            getFavoriteSectionEmptyMessage={getFavoriteSectionEmptyMessage}
          />

          <MoviesRoadmapSection nextSteps={MOVIES_NEXT_STEPS} />

          <MoviesAdminAccessSection
            onOpen={handleOpenAdminAccessModal}
            isEnabled={isMoviesAdminSurfaceEnabled}
          />

          <MoviesCtaSection />
        </div>
      </div>

      {isMoviesAdminSurfaceEnabled ? (
        <MoviesAdminAccessModal
          isOpen={isAdminAccessModalOpen}
          adminSecret={adminSecret}
          adminAccessStatus={adminAccessStatus}
          adminAccessMessage={adminAccessMessage}
          onClose={handleCloseAdminAccessModal}
          onSubmit={handleAdminAccessSubmit}
          onSecretChange={(event) => setAdminSecret(event.target.value)}
        />
      ) : null}
    </>
  );
};

export default Movies;
